// src/components/Sections/MembershipIdentitySection/MembershipIdentitySection.jsx

import React from 'react';
import './MembershipIdentitySection.scss';

import homeScreenshot from '../../../assets/images/marketing/ttg-home-dashboard-phone.png';

const memberBenefits = [
  'One golf identity across every public course you play',
  'Your groups, Series, rounds, and golf history together',
  'Founding Member recognition from the beginning',
  'A community designed to extend into real-world experiences'
];

export default function MembershipIdentitySection() {
  return (
    <section
      id="membership-identity"
      className="membership-v4 section-v2 section-v2--dark"
    >
      <div className="membership-v4__pattern" aria-hidden="true">
        THE TOUR · THE TOUR · THE TOUR · THE TOUR · THE TOUR
      </div>

      <div className="container membership-v4__layout">
        <div className="membership-v4__copy">
          <p className="eyebrow eyebrow--light">
            More than an account
          </p>

          <h2>
            You are not creating another golf account.
            <span>You are joining The Tour.</span>
          </h2>

          <p>
            Your golf does not have to reset every time you tee off.
            Keep your rounds, playing partners, season achievements, and
            competition in one member profile—a place to belong beyond
            any single public course.
          </p>

          <ul>
            {memberBenefits.map((benefit) => (
              <li key={benefit}>{benefit}</li>
            ))}
          </ul>
        </div>

        <div className="membership-v4__visual">
          <figure className="membership-v4__phone">
            <img
              src={homeScreenshot}
              alt="The Tour Golfers member dashboard"
              loading="lazy"
            />
          </figure>

          <div className="membership-v4__seal" aria-hidden="true">
            <span>The Tour Golfers</span>
            <strong>TG</strong>
            <small>Founding Class · 2027</small>
          </div>

          <div className="membership-v4__card">
            <div className="membership-v4__watermark" aria-hidden="true">
              TG
            </div>

            <div className="membership-v4__card-top">
              <span>The Tour Golfers</span>
              <small>Founding Member</small>
            </div>

            <div className="membership-v4__card-middle">
              <small>Tour Member</small>
              <strong>Jack Jameson</strong>
              <span>Oakville · Ontario</span>
            </div>

            <div className="membership-v4__card-bottom">
              <div>
                <small>Member since</small>
                <strong>2027</strong>
              </div>

              <div>
                <small>Member no.</small>
                <strong>Example</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
